/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

/* see: https://stackoverflow.com/a/52809105 */
history.pushState = ((f) =>
  function pushState(): any {
    // eslint-disable-next-line prefer-rest-params
    const ret = f.apply(this, arguments);

    window.dispatchEvent(new Event('pushState'));
    window.dispatchEvent(new Event('locationchange'));

    return ret;
  })(history.pushState);

history.replaceState = ((f) =>
  function replaceState(): any {
    // eslint-disable-next-line prefer-rest-params
    const ret = f.apply(this, arguments);

    window.dispatchEvent(new Event('replaceState'));
    window.dispatchEvent(new Event('locationchange'));

    return ret;
  })(history.replaceState);

window.addEventListener('popstate', () => {
  window.dispatchEvent(new Event('locationchange'));
});
